import gatewayRoutes from '../../gateway-routes.json';
import { isReactGatewayPath as matchReactGatewayPath } from './gateway-routes';

export const GATEWAY_HOP_STORAGE_KEY = 'sihc.gateway.hop';

export const reactGatewayPrefixes: readonly string[] = gatewayRoutes.prefixes;

/// <summary>
/// Whether this URL is served by the React SPA at the nginx gateway.
/// </summary>
export function isReactGatewayPath(url: string): boolean {
    return matchReactGatewayPath(url, reactGatewayPrefixes);
}

function isGatewayHopDark(): boolean {
    const css = document.getElementById('layout-css') as HTMLLinkElement | null;
    return !!(
        css?.href?.includes('dark') ||
        document.documentElement.classList.contains('dark') ||
        document.body?.classList.contains('dark')
    );
}

/// <summary>
/// Persist a hop flag so the next document can show the loading overlay before paint,
/// and show the overlay on the current document immediately.
/// </summary>
export function markGatewayHop(): void {
    const dark = isGatewayHopDark();
    try {
        sessionStorage.setItem(GATEWAY_HOP_STORAGE_KEY, dark ? 'dark' : '1');
    } catch {
        /* private mode */
    }
    document.documentElement.classList.add('sihc-gateway-hopping');
    if (dark) {
        document.documentElement.classList.add('sihc-gateway-hop-dark');
    }
}

/// <summary>
/// Clears the hop overlay after the destination SPA has booted.
/// </summary>
export function clearGatewayHopOverlay(): void {
    try {
        sessionStorage.removeItem(GATEWAY_HOP_STORAGE_KEY);
    } catch {
        /* ignore */
    }
    document.documentElement.classList.remove('sihc-gateway-hopping', 'sihc-gateway-hop-dark');
}

/// <summary>
/// Full navigation so nginx can choose Angular vs React.
/// </summary>
export function assignGatewayHop(url: string): void {
    markGatewayHop();
    const href = url.startsWith('/') || url.startsWith('http') ? url : `/${url}`;
    const go = () => {
        window.location.assign(href);
    };
    const doc = document as Document & {
        startViewTransition?: (cb: () => void) => unknown;
    };
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
    if (typeof doc.startViewTransition === 'function' && !reduced) {
        try {
            doc.startViewTransition(go);
            return;
        } catch {
            /* fall through */
        }
    }
    go();
}
